import React, { useEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import Animated, { Easing, useAnimatedStyle, useReducedMotion, useSharedValue, withTiming } from 'react-native-reanimated';
import { colors, gradients, radius, spacing } from '../../theme/tokens';

export interface BarreProgressionProps {
  faites: number;
  total: number;
  etiquette: string;
}

/**
 * Suit les étapes RENDUES par le serveur, rien d'autre : le remplissage glisse d'un palier au
 * suivant, il n'avance jamais seul entre deux retours (aucune fausse progression).
 */
export function BarreProgression({ faites, total, etiquette }: BarreProgressionProps) {
  const reduit = useReducedMotion();
  const part = useSharedValue(faites / total);
  useEffect(() => {
    part.value = reduit ? faites / total : withTiming(faites / total, { duration: 500, easing: Easing.inOut(Easing.cubic) });
  }, [faites, total, reduit, part]);
  const remplissage = useAnimatedStyle(() => ({ width: `${part.value * 100}%` }));

  return (
    <View
      style={styles.piste}
      accessible
      accessibilityRole="progressbar"
      accessibilityLabel={etiquette}
      accessibilityValue={{ min: 0, max: total, now: faites }}
    >
      <Animated.View style={[styles.remplissage, remplissage]} testID="progression-remplissage">
        <LinearGradient colors={[...gradients.accent]} start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} style={StyleSheet.absoluteFill} />
      </Animated.View>
    </View>
  );
}

const styles = StyleSheet.create({
  piste: { height: spacing.sm, borderRadius: radius.pill, backgroundColor: colors.inkSoft, overflow: 'hidden' },
  remplissage: { height: '100%', borderRadius: radius.pill, overflow: 'hidden' },
});
